
import { TrendingUp } from 'lucide-react';

const HeroSection = () => {
  return (
    <section className="relative bg-gradient-to-br from-blue-600 via-blue-700 to-blue-800 py-24">
      <div className="absolute inset-0 bg-black/20"></div>
      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h1 className="text-4xl md:text-6xl font-bold text-white mb-6">
          Administra tu propiedad <br />
          <span className="text-blue-200">con Estancia Corta</span>
        </h1>
        <p className="text-xl md:text-2xl text-blue-100 mb-8 max-w-3xl mx-auto leading-relaxed">
          Nos encargamos de todo para que tú solo te preocupes por tus ingresos
        </p>
        <div className="inline-flex items-center bg-white/10 backdrop-blur-sm rounded-full px-6 py-3 text-white border border-white/20">
          <TrendingUp className="w-5 h-5 mr-2 text-green-300" />
          <span className="font-semibold">
            Comisión competitiva: 20% sobre ingresos + $1,500 MXN mensuales
          </span>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
